const TOKEN = {
    approfondimenti: "rTS8JvHsWu1pbX7rU4SE0AsItFrnHVNoctSafv8HMYAIB9oZ1v815RX1aLqcQtThMWmTe8oP3DpBehBZVRR6ucg2VuPQLvw3r60UjTkYdSoRRZrgK7OmNXJP",
    biblioteca: "rTS8JvHsWu1pbX7rU4SE0AsItFrnHVNoctSafv8HMYAIB9oZ1v815RX1aLqcQtThMWmTe8oP3DpBehBZVRR6ucg2VuPQLvw3r60UjTkYdSoRRZrgK7OmNXJP",
    electronapp: "rTS8JvHsWu1pbX7rU4SE0AsItFrnHVNoctSafv8HMYAIB9oZ1v815RX1aLqcQtThMWmTe8oP3DpBehBZVRR6ucg2VuPQLvw3r60UjTkYdSoRRZrgK7OmNXJP"
}

export default TOKEN